﻿import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import { ShowHide } from 'components/layout/ShowHide';
import { FormHelperText } from "components/form-fields";
import 'components/listing/Listing.css';

export function Table(
    {
        data = [],
        headerData = {},
        loadingData = false,
        fitToContent = false,
        dangerHelperText = null,
        shrinkLastColumn = false,
        noWrap = false,
        columnClasses = [],
        columnWidths = [],
        loadingClass = "bp6-skeleton",
        tableClasses = "",
        loading
    }
) {

    function generateCoumnStyle(index) {
        if(columnWidths && columnWidths.length > index){
            return { width: columnWidths[index] };
        }

        return {};
    }

    return (
        <Fragment>
            <table className={classNames('bp6-html-table', 'bp6-html-table-striped', 'listing-table', { "nowrap-table": noWrap }, tableClasses)}
                style={{ width: fitToContent ? "initial" : "100%" }}>
                <ShowHide
                    evaluator={headerData?.headers?.length > 0 || headerData?.topLevelHeaders?.length > 0}
                    show={(
                        <thead>
                            <ShowHide
                                evaluator={!!headerData?.topLevelHeaders?.length}
                                show={
                                    <tr className='listing-table-top-level-header'>
                                        {headerData?.topLevelHeaders?.map((header, index) => {
                                            return (
                                                <th
                                                    key={header.key}
                                                    colSpan={header.colspan ? header.colspan : 1}
                                                    className={classNames({ "table-header-small": shrinkLastColumn && index === headerData.headers.length - 1 })}
                                                    style={generateCoumnStyle(index)}
                                                >
                                                    {header.value}
                                                </th>
                                            );
                                        })}
                                    </tr>
                                }
                            />
                            <tr>
                                {headerData.headers.map((header, index) => {
                                    let columnClass = columnClasses[index] ?? null;
                                    return (
                                        <th key={header.key} className={classNames({ "table-header-small": shrinkLastColumn && index === headerData.headers.length - 1 }, columnClass)} style={generateCoumnStyle(index)}>
                                            {header.value}
                                        </th>
                                    );
                                })}

                                {headerData.additionalHeaders}
                            </tr>
                        </thead>
                    )}
                />
                <tbody>
                    <Fragment>
                        {
                            data.map((row) => {
                                return (
                                    <tr key={row.key} className={row.class} onClick={row.onRowClick}>
                                        {row.cells.map((cell, colIndex) => {
                                            let columnClass = columnClasses[colIndex] ?? null;
                                            let spanClass = loadingData ? loadingClass : null;

                                            // For nested tables - see if the cell is an object with nested content/colSpan or primary value
                                            const isObjectCell = typeof cell === 'object' && cell !== null && 'content' in cell;
                                            const cellContent = isObjectCell ? cell.content : cell;
                                            const cellColSpan = isObjectCell && cell.colSpan ? cell.colSpan : 1;

                                            return (
                                                <td
                                                    key={`${row.key}-${colIndex}`}
                                                    colSpan={cellColSpan}
                                                    className={columnClass}
                                                    style={generateCoumnStyle(colIndex)}
                                                >
                                                    <span className={classNames(spanClass)}>
                                                        {cellContent}
                                                    </span>
                                                </td>
                                            );
                                        })}
                                        {row.additionalCells}
                                    </tr>
                                );
                            })
                        }
                    </Fragment>
                </tbody>
            </table>
            <div className={classNames({ "form-field": dangerHelperText && dangerHelperText.length > 0 })}>
                <FormHelperText loading={loading} danger={true}>{dangerHelperText}</FormHelperText>
            </div>
        </ Fragment>
    );
}

Table.propTypes = {
    data: PropTypes.array,
    headerData: PropTypes.object,
    loadingData: PropTypes.bool,
    fitToContent: PropTypes.bool,
    dangerHelperText: PropTypes.node,
    shrinkLastColumn: PropTypes.bool,
    noWrap: PropTypes.bool,
    columnClasses : PropTypes.array,
    columnWidths : PropTypes.array,
    loadingClass: PropTypes.string,
    tableClasses: PropTypes.string
};
